import { render, staticRenderFns } from "./TicketInfoCard.vue?vue&type=template&id=585b03cd&"
import script from "./TicketInfoCard.vue?vue&type=script&lang=js&"
export * from "./TicketInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports